<!--
 * @Author: your name
 * @Date: 2022-01-06 10:08:11
 * @LastEditTime: 2023-06-15 20:56:51
 * @LastEditors: HTT httishere0728@gmail.com
 * @Description: 访问需要访问口令
 * @FilePath: /notion/widgets/src/views/Code.vue
-->
<template>
  <div class="container">
    <!-- <img src="@/assets/bg-2.svg" alt="" class="bg" /> -->
    <div class="code-box">
      <h2>𝕎𝕚𝕕𝕧𝕖𝕣𝕤𝕖 · 汪汪汪世界</h2>
      <div class="inner">
        <!-- <el-input
          prefix-icon="el-icon-lock"
          class="input-code"
          placeholder="请输入访问口令"
          v-model="code"
          show-password
        ></el-input> -->
        <input
          :type="code_type"
          class="input-code"
          v-model="code"
          placeholder="请输入访问口令"
        />
        <i class="el-icon-view" @click="triggerCodeType" />
        <div class="code-btn" @click="checkCode">
          <i class="el-icon-right" color="#333333"></i>
        </div>
      </div>
      <br />
      <p class="msg">口令区分大小写</p>
      <p class="msg">
        组件库的<strong>访问口令会不定期进行更新</strong>
      </p>
      <br />
      <!-- <div class="ways">
        <div class="ways-item">
          微信公众号
          <img src="@/assets/wechat.png" />
        </div>
      </div> -->
      <p class="msg">
        小红书：<a target="blank" href="https://www.xiaohongshu.com/user/profile/5c049fc9000000000800af53?xhsshare=WeixinSession&appuid=5c049fc9000000000800af53&apptime=1664074455">@肥汪卷</a> ｜ B站：<a href="https://space.bilibili.com/19225439?spm_id_from=333.1007.0.0" target="blank">@阿汪同学</a> |
        微信公众号：<a href="#">汪汪汪世界</a>
      </p>

      <el-link
        href="/#/"
        :underline="false"
        icon="el-icon-d-arrow-left"
        class="home"
        >返回主页</el-link
      >
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      code: "",
      code_type: "password"
    };
  },
  mounted() {},
  methods: {
    checkCode() {
      const _this = this;
      if (!this.code)
        return this.$message({
          message: "请输入正确的访问口令",
          center: true,
          type: "error",
        });
      if (md5(this.code) === this.$token) {
        this.$message({ message: "访问成功", center: true, type: "success" });
        localStorage.setItem("token", md5(this.code));
        setTimeout(function () {
          _this.$router.push({ name: "lib" });
        }, 2000);
      } else {
        return this.$message({
          message: "口令错误",
          center: true,
          type: "error",
        });
      }
    },
    triggerCodeType() {
      let _t = this.code_type === "text" ? "password" : "text";
      this.code_type = _t;
    }
  },
};
</script>
<style lang="less" scoped>
@import "../less/var.less";
.container {
  width: 100vw;
  height: 100vh;
  position: relative;
  // background-color: rgba(0, 0, 0, 0.1);
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    filter: blur(10px);
  }
  h2 {
    font-size: 0.96rem;
    text-align: center;
    margin-bottom: 0.6667rem;
  }
  .code-box {
    width: 12rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #333333;
    .inner {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    .input-code {
      width: 5.333333rem;
      height: 1.066667rem;
      border-radius: 1.0666667rem;
      border: 0.066667rem solid #333333;
      background-color: transparent;
      padding: 0 0.366667rem;
      color: #333333;
      font-size: 0.426667rem;
      margin-right: 0.266667rem;
    }
    .el-icon-view {
      position: absolute;
      right: 4rem;
      cursor: pointer;
      color: #999999;
      &:hover {
        color: #333333;
      }
    }
    .code-btn {
      display: inline-block;
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.3);
      border: 0.066667rem solid #333333;
      text-align: center;
      line-height: 0.8rem;
      font-size: 0.48rem;
      cursor: pointer;
      transition: all 0.1s ease-in-out;
      &:hover {
        box-shadow: 0 0 0.266667rem 0.026667rem rgba(0, 0, 0, 0.1);
        transform: translateY(-0.066667rem);
      }
    }
    .msg {
      text-align: center;
      a {
        color: @focus-color;
        opacity: 0.5;
      }
    }
    .ways {
      display: flex;
      justify-content: space-between;
      &-item {
        text-align: center;
        img {
          display: block;
          width: 90%;
        }
      }
    }
  }
}
.home {
  display: inline-block;
  margin: 15px auto;
  font-size: 18px;
}
</style>
